//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.EventState
import com.tixforgigs.apax.models.Organizer
import com.tixforgigs.apax.models.Venue

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The event model
* 
* @param beginsAt The date and time when the event begins
* @param eventState 
* @param id The unique event id
* @param organizer 
* @param title The localized event title
* @param description The localized description of the event
* @param doorsOpenAt The date and time when the event opens
* @param endsAt The date and time when the event ends
* @param headerImageId The header image id of the event. requesting images via \"Common Media\" endpoints
* @param iconImageId The icon (avatar) image id of the event. requesting images via \"Common Media\" endpoints
* @param subTitle The localized subtitle of the event
* @param timeZoneId The time zone id.
* @param venue 
*/
@Serializable

data class Event (


      /* The date and time when the event begins */
    @SerialName(value = "beginsAt") @Required val beginsAt: kotlin.time.Instant,


      @SerialName(value = "eventState") @Required val eventState: EventState?,


      /* The unique event id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      @SerialName(value = "organizer") @Required val organizer: Organizer?,


      /* The localized event title */
    @SerialName(value = "title") @Required val title: kotlin.String,


      /* The localized description of the event */
    @SerialName(value = "description") val description: kotlin.String? = null,


      /* The date and time when the event opens */
    @SerialName(value = "doorsOpenAt") val doorsOpenAt: kotlin.time.Instant? = null,


      /* The date and time when the event ends */
    @SerialName(value = "endsAt") val endsAt: kotlin.time.Instant? = null,


      /* The header image id of the event. requesting images via \"Common Media\" endpoints */
    @SerialName(value = "headerImageId") val headerImageId: kotlin.uuid.Uuid? = null,


      /* The icon (avatar) image id of the event. requesting images via \"Common Media\" endpoints */
    @SerialName(value = "iconImageId") val iconImageId: kotlin.uuid.Uuid? = null,


      /* The localized subtitle of the event */
    @SerialName(value = "subTitle") val subTitle: kotlin.String? = null,


      /* The time zone id. */
    @SerialName(value = "timeZoneId") val timeZoneId: kotlin.String? = "Europe/Berlin",


      @SerialName(value = "venue") val venue: Venue? = null


) {




  }

